<template>

 <div class="grid mb-2" >

<div class="col-12 section_wrap  py-2 mb-2">
<div class="grid">
<div class="col-10 md:col-11 pl-3 sortable_element_section_name pt-1 pb-0"  @click="toggleChildren(group.id)"  @dblclick="gotoGroup">
  <p class="text-primary mt-1 mb-0 pt-1 font-bold" >{{getTheTranslation(group,"translation")}}</p>
  </div>


  <div class="col-2 md:col-1 sortable_element_section_name pt-1 pb-0">

    <Button type="button"  icon="pi pi-ellipsis-h" @click="toggleMenu" aria-haspopup="true" :aria-controls="'line_menu'+group.id" class="p-button-primary p-button-text p-button-sm mt-0"   />
    <Menu :id="'line_menu'+group.id" ref="menu" :model="groupdropdown" :popup="true">
    <template #item="{item}">  
    <a class="p-menuitem-link" role="menuitem" @click="item.command(group.id)">
    <span :class="'p-menuitem-icon '+item.icon"></span>
    <span class="p-menuitem-text">{{item.label}}</span>
    <span class="p-ink"></span></a>
    </template>
    </Menu> 

  </div>
</div>
</div>

  

  <div class="col-12 border-primary	border-1	" v-if="show_attributes">
  	<template v-if="loading">
	<FrameOverlay></FrameOverlay>
	</template>

	<template v-else>
		
			<draggable 
			v-model="items"
			:data_container_id="'group_'+group.id"
			class="list-group" 
			group="ungrouped" 
			@start="start" 
			@end="end" 
			@change="change"
			v-bind="dragOptions"
			item-key="id">
			<template #header>
		    <div class="flex align-items-center justify-content-center mb-4 mt-4" v-if="!items.length">
			<h3 class="text-primary font-medium">Henüz hiç kayıt eklenmemiş</h3>
			</div>
		  </template>
			<template #item="{element}">
			<CustomAttributeLine :attribute="element" />
			</template>
			</draggable>
			
		
	</template>


  </div>


  </div>
</template>

<script>
export default {

  name: 'CustomAttributeGroupLine',
  props:["group"],
  data () {
    return {    
      show_attributes:false,
      loading:true,
      drag:false,
      items:[],
      groupdropdown: [
        {
                label: 'Düzenle',
                icon: 'pi pi-pencil',
                command: (id) => {
                     this.gotoPage("BrandCustomAttributeGroup", { group_id:id })
                  }
            },
            {
                label: 'Sil',
                icon: 'pi pi-trash',
                command: (id) => {
                    console.log(id)
                     this.deleteItem("custom_attribute_group",id)
                  }
            },
      ],

    }
  },
  computed: {
    dragOptions() {
      return {
        animation: 200,
        disabled: false,
        ghostClass: "ghost"
      };
    },
    deletedstate()
    {
      return this.$store.state.ui.deletedstate
    },
  },
  watch:{
    deletedstate(newVal,oldVal)
    {
      if(newVal)
      {
        this.$emit("groupdeleted",this.group.id)
      }
    },
  },
  methods:{
  	change(event)
  	{
  		console.log(this.group.id)
  		console.log(this.items)
  	  let formdata = new FormData()
      let list = this.items.map(item=>item.id)
      formdata.append("list",JSON.stringify(list))
      this.silentSubmission(formdata,"custom_attributes/reorder_group_attributes/"+this.group.id,this.afterChange)

    },
    afterChange(response)
    {

    },
  	end(event)
  	{
  		this.drag = false
  	},
  	start(event)
  	{
  		this.drag = true
  	},
  	toggleMenu(event) {
      this.$refs.menu.toggle(event);
    },
    toggleChildren()
    {
    	this.show_attributes = !this.show_attributes
    	if(this.show_attributes)
    	{
    		this.getData()
    	}
    },
    async getData()
    {
    	this.loading = true

    	this.items = await this.generalApiGetWithoutLoader("custom_attributes/brand_group_attributes/"+this.group.id)
    	this.loading = false
    },
    gotoGroup()
    {
      this.$router.push({ name: 'BrandCustomAttributeGroup', params: { group_id:this.group.id} }) 
    },
  }
}
</script>

<style lang="css" scoped>
</style>